import React, {useEffect} from 'react';
import {useQuery} from '@apollo/client';
import {useNavigate, useParams} from 'react-router-dom';
import {
  GetNativeIdFromCuro,
  GetNativeIdFromCuroVariables,
} from '../../schema-types/GetNativeIdFromCuro';
import {GET_NATIVE_ID_FROM_CURO} from '../TestSetupPages/TestHomepage';
import {OneViewModelTypesEnum} from '../../schema-types/globalTypes';
import validateUUID from '../../utils/validateUUID';

export const AccountRedirect: React.FC<{folder?: string}> = ({folder = ''}) => {
  const {curoId} = useParams<{curoId: string}>();
  const navigate = useNavigate();
  const {data, loading, error} = useQuery<
    GetNativeIdFromCuro,
    GetNativeIdFromCuroVariables
  >(GET_NATIVE_ID_FROM_CURO, {
    variables: {
      curoId: validateUUID(curoId)!,
      modelName: OneViewModelTypesEnum.ACCOUNT,
    },
    skip: !validateUUID(curoId),
  });

  useEffect(() => {
    if (data?.nativeId) {
      const redirectUrl = `/account/${data.nativeId}/${folder}`;
      navigate(redirectUrl);
    }
  }, [data, navigate]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return <p>Redirecting...</p>;
};
